import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { openModal, closeModal } from "../../actions/modalAction";
import { createUser } from "../../actions/authAction";
import { withRouter } from "react-router-dom";

import { Segment, Form, Button, Header, Popup } from "semantic-ui-react";
import TextInput from "../form/TextInput";
// import TextArea from "../form/TextArea";
// import SelectInput from "../form/SelectInput";
import CheckboxInput_2 from "../form/CheckboxInput_2";
//import { city, state, } from "./Data";
import { composeValidators, combineValidators, isRequired } from "revalidate";
import {
  isValidEmail,
  isValidPhone,
  isValidPassword,
} from "../validator/revalidator";
var passwordValidator = require("password-validator");

const validate = combineValidators({
  //************user */

  userId: composeValidators(
    isRequired("User Mobile as user ID"),
    isValidPhone({})
  )(),
  uemail: composeValidators(
    // isRequired("User Email"), 
    isValidEmail({}))(),
  password: composeValidators(isRequired("Password"), isValidPassword({}))(),
  uphone2: isValidPhone({}),
  uname: isRequired("User Name"),
  // password:isRequired('Password') ,
  password2: isRequired("Confirm Password"),
  //*********company */

  

  // address:isRequired('Address') ,
  // locality:isRequired('Locality') ,
  // city:isRequired('City/District') ,
  // state:isRequired('State') ,
  // pincode:isRequired('Pincode') ,
});

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(16) // Maximum length 16
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits() // Must have digits
  .has()
  .symbols() // Must have symbols
  .has()
  .not()
  .spaces() // Should not have spaces
  .is()
  .not()
  .oneOf(["Passw0rd", "Password123"]); // Blacklist these values

class UserCreate extends Component {
  state = {
    showP: false,
    modalOpen: false,
    activeSubmit: false,
  };
  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false });
  onSubmit = (values) => {
    this.props.createUser(values);
  };
  backButtonHandler = () => {
    this.props.history.goBack();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  toggle = () => this.setState({ showP: !this.state.showP });
  toggleSubmit = () =>
    this.setState({ activeSubmit: !this.state.activeSubmit });
  //****************** */
  handleTermsAndConditionsModal = () => {
    this.props.openModal("TermsAndConditionsModal");
  };
  //*************** */
  render() {
    const showPass = this.state.showP ? "text" : "password";

    const { handleSubmit, pristine, reset, submitting } = this.props;

    const { password, password2 } =
      this.props.state.form &&
      this.props.state.form.CreateUser !== undefined &&
      this.props.state.form.CreateUser.values !== undefined &&
      this.props.state.form.CreateUser.values;

    const renderMatchPassword = () => {
      if (password && password2) {
        if (password !== password2) {
          return (
            <div style={{ color: "red" }}>
              <b>Password do not match</b>
            </div>
          );
        }
      }
    };
    //************************* */

    // const renderPasswordError = () => {
    //  if(password) return schema.validate(password, { list: true }).map(item => {
    //   return (
    //     <span
    //     style={{color:'red'}}
    //     key={item}>
    //     {" "}
    //     <b>{item} ,</b>
    //     </span>
    //   );
    //   });
    // };

    const renderPasswordError = (val) => {
      if (val)
        return schema.validate(val, { list: true }).map((item) => {
          return (
            <span style={{ color: "red" }} key={item}>
              {" "}
              <b>{item} ,</b>
            </span>
          );
        });
    };

    //************************ */

    //*************************** */
    return (
      <div>
        <div style={{ maxWidth: "700px", margin: "auto" }}>
          <br />

          <Segment
            textAlign="center"
            attached
            inverted
            color="teal"
            style={{ border: "none" }}
          >
            <Header
              // color="blue"
              content="Register"
            />
          </Segment>

          <div className="card-form ">
            <div className=" label">
              <Form
                style={{ padding: 10 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.closeModal}
                >
                  Cancel
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <br />
                <br />
                <div>
                  (All field marked with{" "}
                  <span style={{ color: "red" }}>
                    <b>*</b>
                  </span>{" "}
                  are required)
                </div>
                <Header color="teal" content="User's Details" />
                
              
                <label>User's Name</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>
                <Field
                  name="uname"
                  type="text"
                  component={TextInput}
                  placeholder="First Name Last Name"
                />
                <label>User's Mobile as user ID</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>
                <Field
                  name="userId"
                  type="text"
                  component={TextInput}
                  placeholder="Enter Ten Digits Mobile Number"
                />
                <label>User's Mobile2</label>
                <Field
                  name="uphone2"
                  type="text"
                  component={TextInput}
                  placeholder="Enter Ten Digits Mobile Number"
                />
                <label>User's Email</label>{" "}
                {/* <span style={{ color: "red" }}>
                  <b>*</b>
                </span> */}
                <Field
                  name="uemail"
                  type="email"
                  component={TextInput}
                  placeholder="User's Email"
                />
                {/* address of user */}
                {/* <label>Address</label>{' '}<span style={{color:'red'}}><b>*</b></span>
            <Field
              name="address"
              type="text"
              component={TextInput}
              placeholder="Address"
            /> */}
                {/* <label htmlFor="">Locality</label>{' '}<span style={{color:'red'}}><b>*</b></span>
            <Field
              name="locality"
              placeholder="Locality"
              type="text"
              options={locality()}
              //search={true}
              component={SelectInput}
            /> */}
                {/* <label>City/District</label>{' '}<span style={{color:'red'}}><b>*</b></span>
            <Field
              //search={true}
              name="city"
              type="text"
              component={SelectInput}
              options={city()}
              placeholder="City/District"
            />
            <label>State</label>{' '}<span style={{color:'red'}}><b>*</b></span>
            <Field
              //search={true}
              name="state"
              type="text"
              component={SelectInput}
              options={state()}
              placeholder="State"
            />
            <label>Pincode</label>{' '}<span style={{color:'red'}}><b>*</b></span>
            <Field
              name="pincode"
              type="text"
              component={TextInput}
              placeholder="Pincode"
            />
            <label>Tell us about you</label>
            <Field
              name="description"
              type="text"
              component={TextArea}
              rows={3}
              placeholder="Tell us about you"
            /> */}
                {/*  */}
                <label>Password</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>{" "}
                <Popup trigger={<span>hint?</span>} wide="very">
                  Password Must have Minimum eight and maximum 16 characters, at
                  least one uppercase letter, one lowercase letter, one number,
                  one special character and no spaces
                </Popup>{" "}
                {renderPasswordError(password)}
                <Field
                  //onBlur=
                  name="password"
                  type={showPass}
                  component={TextInput}
                  placeholder="e.g. @Ab12345"
                />
                <label>Confirm Password</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>
                <Field
                  name="password2"
                  type={showPass}
                  //type="password"
                  component={TextInput}
                  placeholder="Confirm Password"
                />
                <CheckboxInput_2
                  label="Show Password"
                  onChange={this.toggle}
                  checked={this.state.showP}
                />
                {renderMatchPassword()}
                <br />
                {/*  */}
                <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                  <b>
                    {" "}
                    By Signup you agree to
                    <span
                      className="format-term-a"
                      onClick={this.handleTermsAndConditionsModal}
                    >
                      Terms & Conditions
                    </span>{" "}
                  </b>
                  <div>
                    <CheckboxInput_2
                      label="I agree"
                      onChange={this.toggleSubmit}
                      checked={this.state.activeSubmit}
                    />
                  </div>
                </div>
                {/*  */}
                <Button
                  color="olive"
                  type="submit"
                  disabled={!this.state.activeSubmit}
                >
                  Signup
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
              </Form>
              <br /> <br /> <br />
            </div>
          </div>
        </div>
        {/*  */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    state,
  };
};
export default connect(mapStateToProps, { createUser, openModal, closeModal })(
  reduxForm({
    form: "CreateUser", // a unique identifier for this form
    destroyOnUnmount: false,
    validate,
  })(withRouter(UserCreate))
);
